
import React, { Fragment, useEffect, useState } from 'react';
import { ArrowLeft, ArrowRight } from 'react-feather';
import SidebarMenuItems from './SidebarMenuItems';
import ConfigDB from '../../Config/ThemeConfig';
import Sidebarimgsection from './Sidebarimgsection';
import Popup from '../../Components/Common/Popup/popup';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

const SidebarMenu = ({ width }) => {
  const [rightArrow, setRightArrow] = useState(false);
  const [leftArrow, setLeftArrow] = useState(false);
  const authState = useSelector((state) => state.auth);
  const sidebar_types = localStorage.getItem('sidebar_types');
  const wrapper = sidebar_types || ConfigDB.data.settings.sidebar.type;
  const [margin, setMargin] = useState(0);
  const [modal, setModal] = useState(false);
  const navigate = useNavigate()

  // const today = new Date().toISOString().split("T")[0];


  useEffect(() => {
    setLeftArrow(true);
    // const lastOpened = localStorage.getItem("modalLastOpened");

    // if (lastOpened !== today) {
    //   setModal(true);
    //   localStorage.setItem("modalLastOpened", today);
    // }
  }, []);

  // const handleModal = () => {
  //   localStorage.setItem("modalLastOpened", today);
  //   setModal(!modal)
  // }
  // const handleGoMessage = () => {
  //   localStorage.setItem("modalLastOpened", today);
  //   if (authState.userRole === 1) {
  //     navigate('/settings/message-credit')
  //   }
  //   setModal(false)

  // }

  const scrollToRight = () => {
    if (margin <= -2598 || margin <= -2034) {
      if (width === 492) {
        setMargin(-3570);
      } else {
        setMargin(-3464);
      }
      setRightArrow(true);
      setLeftArrow(false);
    } else {
      setLeftArrow(false);
      setMargin(margin => (margin += -width));
    }
  };

  const scrollToLeft = () => {
    if (margin >= -width) {
      setMargin(0);
      setLeftArrow(true);
      setRightArrow(false);
    } else {
      setMargin(margin => (margin += width));
      setRightArrow(false);
    }
  };

  return (
    <Fragment>
      <nav className='sidebar-main'>
        <div className={`left-arrow ${leftArrow ? 'd-none' : ''}`} id="left-arrow" onClick={scrollToLeft}><ArrowLeft /></div>
        <div id="sidebar-menu">
          <SidebarMenuItems wrapper={wrapper} margin={margin} />
        </div>
        <div className={`right-arrow ${rightArrow ? 'd-none' : ''}`} onClick={scrollToRight}>
          <ArrowRight />
        </div>
      </nav>
      {/* <Popup title='Update' isOpen={modal} toggler={handleModal} size="lg">
        <div >
          <h4 className="modal-title fw-semibold">
            🚀 New Feature Alert!
          </h4>
          <span>We’re excited to introduce WhatsApp & SMS Notifications in Service CRM</span>
          <br />

          <div className=" mt-3 d-flex flex-column align-items-start justify-content-end">

            <span> <strong> 📄Automatic notifications will be sent when:</strong></span>
            
            <ul>
              <li>• An Invoice is created</li>
              <li>• A Payment is recorded</li>
            </ul>
            <br />
            <span> <strong>🔔 Important:</strong></span>

                  <ul>
              <li>• SMS & WhatsApp notifications are chargeable</li>
              <li>• Notification credits must be added to enable messaging</li>
            </ul>
            <p>👉 Manage notification settings and credits from your dashboard.</p>
            <ul>
              <li>
                <strong>📩 Notification Charges:</strong>
                
              </li>
              <li>
                • SMS: <strong>₹0.22 </strong> per message
              </li>
              <li>
                • WhatsApp: <strong>₹0.22</strong>  per message
              </li>
            </ul>
            <br />
            <span>
              👉 To enable SMS or WhatsApp notifications, please go to :
              <strong className='mx-1'>
                Settings → Message Credit.
              </strong>
              <br />
              <span>
                This update gives you greater flexibility and better control over your communication costs.
               📞 For any questions or support, feel free to contact us.
              </span>
            </span>
          </div>

        </div>
        <div className="d-flex justify-content-end ">
          <button
            className="btn btn-primary px-4 "
            onClick={handleGoMessage}
          >
            {
              authState?.userRole === 1 ? 'Add Message Credit' :
                'I Understood'
            }

          </button>
        </div>

      </Popup> */}
    </Fragment>
  );
};

export default SidebarMenu;
